const stack = [
  { label: 'Frontend', items: ['React', 'Blazor', 'Tailwind CSS', 'HTML/CSS'] },
  { label: 'Backend', items: ['Node.js', 'Express', 'C# / .NET', 'REST APIs'] },
  { label: 'Mobile', items: ['iOS (Swift)', 'Android (Kotlin)'] },
  { label: 'AI & Tools', items: ['OpenAI', 'Claude API', 'Zapier', 'Git'] },
];

export default function About() {
  return (
    <section id="about" className="py-28 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-start">

          {/* Left */}
          <div>
            <span className="text-xs font-medium tracking-widest text-violet-400 uppercase">About</span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mt-3 mb-6">
              Hi, I'm Luis Vega Torres.
            </h2>
            <div className="space-y-4 text-gray-400 text-sm leading-relaxed">
              <p>
                I'm a software developer with <span className="text-white font-medium">20+ years of experience</span> building clean, functional digital products — from business websites to full-scale web and mobile applications.
              </p>
              <p>
                I work across the full stack: React and Node.js for the web, Swift and Kotlin for mobile, and Blazor with C# for enterprise and desktop solutions.
              </p>
              <p>
                I also integrate AI into products — chatbots, automation, smart content — using the latest models to give my clients a real competitive edge.
              </p>
              <p>
                Beyond building AI features, I use AI throughout my own development process — from planning to code review — which means faster delivery, fewer bugs, and lower costs for you.
              </p>
              <p>
                If you have an idea and need someone to build it, I'm your guy.
              </p>
            </div>

            {/* Stats */}
            <div className="flex gap-8 mt-8 pt-8 border-t border-white/[0.06]">
              {[
                { value: '20+', label: 'Years of experience' },
                { value: '4', label: 'Platforms covered' },
                { value: '∞', label: 'Problems solved' },
              ].map(({ value, label }) => (
                <div key={label}>
                  <p className="text-2xl font-bold text-white">{value}</p>
                  <p className="text-xs text-gray-500 mt-0.5">{label}</p>
                </div>
              ))}
            </div>

            <a href="#contact"
              className="inline-flex items-center gap-2 mt-8 bg-violet-600 hover:bg-violet-500 text-white text-sm font-medium px-6 py-3 rounded-lg transition-colors">
              Work with me
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </a>
          </div>

          {/* Right — Stack */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {stack.map(({ label, items }) => (
              <div key={label} className="bg-white/[0.03] border border-white/[0.07] rounded-xl p-5">
                <h4 className="text-xs font-semibold text-violet-400 uppercase tracking-wider mb-3">{label}</h4>
                <ul className="space-y-1.5">
                  {items.map(item => (
                    <li key={item} className="text-sm text-gray-400 flex items-center gap-2">
                      <span className="w-1 h-1 rounded-full bg-violet-500 flex-shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}
